import { DefaultIconResp } from 'types/listing/listings'
import { create } from 'zustand'

type DefaultIconType = 'item-to-bring' | 'allergies'

const defaultIcon = (set: any) => ({
  addDefaultIconModal: false,
  setAddDefaultIconModal: (state: boolean) =>
    set(() => ({ addDefaultIconModal: state })),
  iconFor: null,
  setIconFor: (state: DefaultIconType) => set(() => ({ iconFor: state })),
  defaultData: null,
  setDefaultData: (state: DefaultIconResp | null) =>
    set(() => ({ defaultData: state })),
})

export const defaultIconStore = create(defaultIcon)
